import getCurrentPage from '@functions/getCurrentPage';

import I from '../types.ts';

const checkChange: I['checkChange'] = function () {
    const { storePages, levels } = this.props;
    const currentPage = getCurrentPage({
        storePages,
        filter: (page) => page.parentName === 'public',
    });
    let isChange = false;

    if (this.levels) {
        [1, 2, 3].forEach((key) => {
            if (levels[key] !== this.levels![key]) {
                isChange = true;
            }
        });
    }

    if (currentPage !== this.currentPage || isChange) {
        this.setMenuState({ scrollTop: 0 });

        this.init();

        this.currentPage = currentPage;
        this.levels = [...levels];
    }
};

export default checkChange;
